import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBigPot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 32,
	viewBox: "0 0 34 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.500244 9.0861H33.5002V27.0834C33.5002 28.3565 33.0546 29.4387 32.1634 30.3299C31.2722 31.2211 30.1901 31.6667 28.917 31.6667H5.08353C3.8104 31.6667 2.72823 31.2211 1.83702 30.3299C0.945836 29.4387 0.500244 28.3565 0.500244 27.0834V9.0861ZM3.55577 12.1416V27.0834C3.55577 27.5162 3.70219 27.8791 3.99504 28.1719C4.28785 28.4647 4.65068 28.6111 5.08353 28.6111H28.917C29.3498 28.6111 29.7126 28.4647 30.0055 28.1719C30.2983 27.8791 30.4447 27.5162 30.4447 27.0834V12.1416H3.55577ZM0.500244 7.25276V4.16667H11.8058V2.02776C11.8058 1.59491 11.9522 1.23207 12.245 0.939221C12.5379 0.646407 12.9007 0.5 13.3336 0.5H20.6669C21.0998 0.5 21.4626 0.646407 21.7555 0.939221C22.0483 1.23207 22.1947 1.59491 22.1947 2.02776V4.16667H33.5002V7.25276H0.500244Z",
		fill: "#393A36"
	})
});
export default SvgBigPot;
